import { writable } from 'svelte/store';

type ColorTheme = 'theme-light' | 'theme-dark' | ''
export const theme = writable<ColorTheme>(localStorage.getItem('theme') as ColorTheme || 'theme-light');

export const setTheme = (_theme: ColorTheme):void => {
  localStorage.setItem('theme', _theme)
  theme.set(_theme);
};